import { styled } from "@mui/material/styles";

export const Component = styled("div", {
  label: "price",
})`
  color: ${({ theme }) => theme.palette.color.primary.main};
  font-weight: 500;
  line-height: 1;
  margin-top: ${({ theme }) => theme.spacing(3)};
  position: relative;
  display: flex;
  align-items: baseline;

  ${({ theme }) => theme.breakpoints.up("md")} {
    margin-top: ${({ theme }) => theme.spacing(2)};
  }
`;

export const PriceParts = styled("div", {
  label: "price-parts",
})`
  font-size: 30px;
  position: relative;
  display: flex;
  align-items: baseline;
  flex-wrap: nowrap;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 54px;
    & > .currency {
      font-size: 42px;
      align-self: center;
    }

    & > .fraction {
      font-size: 24px;
    }
  }

  &.uniform-height {
    font-size: ${({ theme }) => theme.spacing(4)};
    & > .currency {
      font-size: ${({ theme }) => theme.spacing(4)};
    }

    & > .fraction {
      font-size: ${({ theme }) => theme.spacing(4)};
    }
  }
`;

export const PriceAdornment = styled("div", {
  label: "price-adornment",
})`
  font-size: ${({ theme }) => theme.spacing(4)};
  margin-right: ${({ theme }) => theme.spacing(1)};

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.spacing(6)};
  }

  &.uniform-height {
    font-size: ${({ theme }) => theme.spacing(4)};
  }
`;
